module.exports = __webpack_public_path__ + "img/geomaps-02.12a04fe3.png";